import './command-button.css';
import React from 'react';
import { Button } from 'reactstrap';

export default (props) => {
  return <Button {...props} className="btn-cmd" />;
};
